import React from 'react';
import { connect } from 'react-redux'
import { View, StyleSheet, Text, Picker, Platform } from 'react-native'
import { Button } from 'react-native-elements'
import UserProfile from './userProfile'
import Option from './web/option'
import { setPredictor, setMoneyplan } from '../redux/actions'
import { dict as predictors } from '../libs/predictors'
import { dict as moneyplanners } from '../libs/moneyplaners'
import TextZ from './TextZ';
import moment from 'moment'

const PickerItem = Platform.OS === 'web' ? Option : Picker.Item;

const noPackage = (pname, pexpire) => {
  switch(pname.toUpperCase()) {
      case '': case null: case 'NONE':
      return true;
  }
  
  if (!pexpire) {
    throw new Error('No package expire date')
  }
  return moment(pexpire).isBefore(moment())
}

class Settings extends React.Component {
    componentDidUpdate() {
        const { subscription, subscription_expire, setPredictor, setMoneyplan, close, predictor, moneyplan, loading } = this.props;
        const vip = !noPackage(subscription, subscription_expire)
        if (!vip) {
            const selectedPredictor = predictors.filter(p => p.module === predictor).pop()
            const selectedMoneyPlaner = moneyplanners.filter(p => p.module === moneyplan).pop()
    
            if (!selectedPredictor.free) {
                console.log(selectedPredictor, predictors.filter(p => p.free).pop().module)
                setPredictor(predictors.filter(p => p.free).pop().module)
            }
            if (!selectedMoneyPlaner.free) {
                setMoneyplan(moneyplanners.filter(p => p.free).pop().module)
            }
        }
    }

    render() {
        const { subscription, subscription_expire, setPredictor, setMoneyplan, close, predictor, moneyplan, loading } = this.props;
        const selectedPredictor = predictors.filter(p => p.module === predictor).pop()
        const selectedMoneyPlaner = moneyplanners.filter(p => p.module === moneyplan).pop()

        if (!selectedPredictor) {
            setPredictor(predictors.filter(p => p.free && p.default).pop().module)
            return null;
        }
        if (!selectedMoneyPlaner) {
            setMoneyplan(moneyplanners.filter(p => p.free && p.default).pop().module)
            return null;
        }

        const vip = !noPackage(subscription, subscription_expire)

        return <View style={styles.container}>
            <View style={styles.main}>
                <UserProfile />


                <TextZ
                style={{ fontWeight: 'bold', textAlign: 'center', fontSize: 20}}
                >ตั้งค่าสูตรบาคาร่า</TextZ>
                <View style={styles.labelRow}>
                    <TextZ
                        style={{ fontWeight: 'bold', textAlign: 'left', fontSize: 16}}
                    >เลือกสูตรแทง
                    </TextZ>
                    <View>
                        <a style={{display: 'flex' }} href='https://www.ufafc.com/baccarat' target="_blank">คืออะไร ?</a>
                    </View>
                </View>
                <Picker
                    selectedValue={selectedPredictor.module}
                    style={{ height: 30,width: '100%', backgroundColor: '#eeeeee', marginBottom: 20 }}
                    onValueChange={(itemValue, itemIndex) =>
                        setPredictor(itemValue)
                    }>
                    {predictors.map(p => (<PickerItem key={p.module} label={`${p.label}${p.note ? ` - ${p.note}` : ''}`} value={p.module} enabled={!!(vip || p.free)} />))}
                </Picker>
                <View style={styles.labelRow}>
                    <TextZ
                        style={{ fontWeight: 'bold', textAlign: 'left', fontSize: 16}}
                    >แผนการเงิน
                    </TextZ>
                    <View>
                        <a style={{display: 'flex' }} href='https://www.ufafc.com/baccarat-money-strategies' target="_blank">คืออะไร ?</a>
                    </View>
                </View>
                <Picker
                    selectedValue={selectedMoneyPlaner.module}
                    style={{ height: 30,width: '100%', backgroundColor: '#eeeeee', marginBottom: 20 }}
                    onValueChange={(itemValue, itemIndex) => {
                        setMoneyplan(itemValue)
                    }}>
                    {moneyplanners.map(p => (<PickerItem key={p.module} label={`${p.label}${p.note ? ` (${p.note})` : ''}`} value={p.module} enabled={!!(vip || p.free)} />))}
                </Picker>
                
            </View>
            <Button
                title="ปิด"
                disabled={!!loading}
                onPress={close}
            />
        </View>
    }
}

const mapStateToProps = state => {
    return {
        predictor: state.settings.predictor,
        moneyplan: state.settings.moneyplan,
        loading: state.app.loading,
        subscription: state.auth.subscription,
        subscription_expire: state.auth.subscription_expire,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        setPredictor: (p) => dispatch(setPredictor(p)),
        setMoneyplan: (p) => dispatch(setMoneyplan(p)),
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(Settings);

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#ffffff',
        padding: 10,
        flex: 1,
        justifyContent: 'space-between',
        minWidth: 280,
        maxWidth: '100%',
        margin: 'auto'
    },
    labelRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    main: {
        flex: 1,
        overflow: 'scroll',
    }
});
  
  